import React from 'react';
import { useSite } from '../../context/SiteContext';

// Adjust an incoming hex color to a lighter/darker variant using luminance mix
function shade(hex, pct) {
  const m = /^#?([0-9a-fA-F]{6})$/.exec(hex || '');
  if (!m) return hex;
  const num = parseInt(m[1], 16);
  let r = (num >> 16) & 0xff, g = (num >> 8) & 0xff, b = num & 0xff;
  const t = pct < 0 ? 0 : 255;
  const p = Math.abs(pct);
  r = Math.round((t - r) * p + r);
  g = Math.round((t - g) * p + g);
  b = Math.round((t - b) * p + b);
  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
}

export default function DealingTerms() {
  const { data } = useSite();
  const dt = data.dealingTerms || {};
  const visible = (data.sectionVisibility || {}).dealingTerms !== false;
  if (!visible || dt.enabled === false) return null;
  const rows = (dt.rows || []).filter((r) => (r?.label || r?.value));
  if (!rows.length) return null;
  const accent = dt.accentColor || '#0ea560';
  const gradient = `linear-gradient(90deg, ${shade(accent, 0.15)} 0%, ${accent} 55%, ${shade(accent, -0.15)} 100%)`;

  return (
    <div id="dealing-terms" className="rounded-xl bg-black border border-zinc-900 px-3 md:px-6 py-8 md:py-10" data-testid="dealing-terms-section">
      <h2 className="text-center text-white text-3xl md:text-5xl font-light tracking-wide mb-8">
        {dt.title || 'DEALING TERMS'}
      </h2>
      <div className="max-w-3xl mx-auto space-y-4 md:space-y-5">
        {rows.map((r, i) => (
          <div key={r.id || i} className="w-full h-[58px] md:h-[66px] select-none flex items-center"
            style={{ background: gradient, transform: 'skewX(-18deg)' }}
            data-testid={`dealing-term-${r.id || i}`}
          >
            <div className="w-full flex items-center justify-between px-6 md:px-8" style={{ transform: 'skewX(18deg)' }}>
              <span className="text-white/95 text-base md:text-xl font-normal">{r.label}</span>
              <span className="text-white text-base md:text-xl font-semibold">{r.value}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
